import { combineReducers } from 'redux';
import authReducer from './auth_reducer';
import roleReducer from './role_reducer';
import signupReducer from './signup_reducer';

export default combineReducers({
                                authReducer,
                                roleReducer,
                                signupReducer,
                            });